import { createFileRoute } from '@tanstack/react-router';
import { getSoftwareCategories } from './-query/api';
export const Route = createFileRoute('/_staff/software/_layout/library/')({
  loader: async () => {
    const categories = await getSoftwareCategories();
    return {
      categories
    } as const;
  }
});